// src/services/payment-mfa.service.ts
import { http } from '../api/http';

export type PaymentProvider = 'paypal';

export interface PaymentMfaRequestContext {
  projectId: number;
  invoiceId: string;
  amount: number;
  currency: 'MXN' | 'USD';
  provider: PaymentProvider;
}


export interface PaymentMfaRequestResponse {
  mfaRequired: true;
  mfaToken: string;
  maskedDestination?: string | null;
  expiresInSeconds?: number | null;
}


export interface PaymentMfaVerifyResponse {
  ok: true;
  verified: true;
  paymentMfaSessionToken?: string;
}

export const PaymentMfaService = {

  request(ctx: PaymentMfaRequestContext) {
    return http<PaymentMfaRequestResponse>('/payments/mfa/request', {
      method: 'POST',
      body: ctx
    });
  },

  
  verify(mfaToken: string, code: string) {
    return http<PaymentMfaVerifyResponse>('/payments/mfa/verify', {
      method: 'POST',
      body: { mfaToken, code }
    });
  }
};
